import { PercentageInput } from "@/lib/components/PercentageInput";
import { Input } from "@/lib/components/Input";
import { useEditorStore } from "@/lib/stores/editor-store/editor-store";
import { cn } from "@/lib/utils";
import { ElementDto, SceneTypeDto } from "@repo/api/overlays";
import { IconBorderCorners, IconLayersSelected } from "@tabler/icons-react";

type Props = {
  element: ElementDto;
  classNameSectionTitle?: string;
  sceneType: SceneTypeDto;
};

export default function ElementAppearanceSection({
  element,
  classNameSectionTitle,
}: Props) {
  const updateElement = useEditorStore((state) => state.service.updateElement);

  return (
    <>
      <div className={cn("input-label mt-8", classNameSectionTitle)}>
        Appearance
      </div>

      <div className="flex gap-4">
        <PercentageInput
          className="w-35"
          value={element.opacity}
          onChange={(opacity) => {
            updateElement(element.externalId, (element) => {
              element.opacity = opacity;
            });
          }}
          leadingComponent={
            <IconLayersSelected
              className="text-text-secondary"
              stroke={1.5}
              size={18}
            />
          }
        />
        {"cornerRadius" in element && (
          <Input
            className="w-[140px]"
            containerSize="sm"
            leadingComponent={
              <IconBorderCorners
                className="text-text-secondary"
                stroke={1.5}
                size={18}
              />
            }
            value={element.cornerRadius}
            onValidateInternalValue={(e) => {
              if (e.target.value === "") {
                return true;
              }

              const isNumber = /^\d+$/.test(e.target.value);

              if (!isNumber) {
                return false;
              }

              const value = parseInt(e.target.value);

              return value >= 0 && value <= 1000001;
            }}
            onValidate={(e) => {
              const isValid = /^\d+$/.test(e.target.value);
              return isValid;
            }}
            onChange={(e) => {
              updateElement(element.externalId, (element) => {
                if (!("cornerRadius" in element)) {
                  throw new Error("Corner radius is not in element");
                }

                element.cornerRadius = parseInt(e.target.value);
              });
            }}
          />
        )}
      </div>
    </>
  );
}
